// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__AYGyQ","logo":"Navbar_logo__2l4jJ"};